import { EntityName } from '@/services/entity/const'
import { entityDetailsPermalink } from '@/services/entity/pageEntities'

export const pages = [
  { path: 'dashboard', icon: 'dashboard' },
  {
    path: 'my-work',
    icon: 'briefcase',
    entity: EntityName.ACTIVITY_CONTACT_RELATION,
    title: 'myWork',
  },
  { path: 'activities', icon: 'activity', entity: EntityName.ACTIVITY },
  { path: 'opportunities', icon: 'fire', entity: EntityName.OPPORTUNITY },
  { path: 'quotes', icon: 'invoice', entity: EntityName.QUOTE },
  { path: 'orders', icon: 'work', entity: EntityName.ORDER },
  { path: 'leads', icon: 'target', entity: EntityName.LEAD },
  { path: 'companies', icon: 'building', entity: EntityName.COMPANY },
  { path: 'persons', icon: 'user-multiple', entity: EntityName.PERSON },
  { path: 'segments', icon: 'list-bullet', entity: EntityName.LIST },
  { path: 'documents', icon: 'file-empty', entity: EntityName.DOCUMENT },
  { path: 'tickets', icon: 'ticket', entity: EntityName.TICKET },
  { path: 'time-tracking', icon: 'clock', title: 'timeTracking' },
  {
    path: 'search-results',
    icon: 'search',
    entity: EntityName.GLOBAL_RESULT,
    title: 'searchResults',
    hidden: true,
  },
  {
    path: 'my-contacts',
    icon: 'user-multiple',
    entity: EntityName.MY_WORK_CONTACT_RELATION,
    title: 'myContacts',
    hidden: true,
  },
] as const

export const detailPages = pages.flatMap((page) =>
  'entity' in page &&
  !['my-work', 'my-contacts', 'search-results'].includes(page.path)
    ? [
        {
          path: entityDetailsPermalink(page.entity),
          entity: page.entity,
          overview: page.path,
        },
      ]
    : [],
)

export function getPage(path: string) {
  return pages.find((page) => page.path === path)
}
